
export const capitalize = (text) => {
  return typeof text !== 'text'
    ? text
    : text
    .toLowerCase()
    .replace(/\w/, firstLetter => firstLetter.toUpperCase())
}
